import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'palette/Button';
import { GRID_SIZES } from '@common/Listing/helpers/constants';
import { selectGrid } from '../actions/listingActions';
import { GRID_COL_NUM } from '../constants';
import { listingGridSelector } from '../selectors/ListingSelector';
import '../styles/Grid.scss';

function Grid({
    customClass = '',
    theme = 'mod1',
    isPremium = true
}) {
    const dispatch = useDispatch();
    const {
        gridViewFromConfig,
        gridOptions,
        gridView
    } = useSelector(listingGridSelector);

    const selectedGrid = gridViewFromConfig ?? gridView;

    const getParsedGrids = () => {
        const parsedGrids = gridOptions
            .map(description => ({
                description,
                isSelected: description === selectedGrid,
                colNum: GRID_COL_NUM[description] || null
            }));

        return isPremium
            ? parsedGrids.sort((a, b) => a.colNum - b.colNum)
            : parsedGrids;
    };

    const handleListItemClick = description => dispatch(selectGrid(GRID_SIZES[description]));

    return (
        <div className={classnames('grid', customClass, { [`grid--${theme}`]: theme })}>
            {isPremium && (
                <span className="grid__title">
                    Display:
                </span>
            )}
            {getParsedGrids().map(({ description, isSelected, colNum }) => (
                isPremium ? (
                    <Button
                        key={description}
                        isTransparent
                        className={classnames(
                            'grid__item',
                            `grid__item--${description}`,
                            {
                                'grid__item--selected': isSelected
                            }
                        )}
                        label={colNum}
                        size="small"
                        theme="secondary"
                        onClick={() => handleListItemClick(description)}
                    />
                ) : (
                    <Button
                        key={description}
                        isTransparent
                        iconName={`row-${description}`}
                        shape="rectangle"
                        onClick={() => handleListItemClick(description)}
                    />
                )))}
        </div>
    );
}

export default Grid;
